<template>
    <el-container>
        <el-header height="auto" class="el-header">
            <headerView />
        </el-header>
        <el-main class="el-main">
            <div class="ch-box" :style="{ background: `url(${background})` }">
                <div class="ch-container">
                    <div class="ch-login-box">
                        <div class="ch-login-left-box">
                            <div class="text-box">
                                <div>欢迎登录</div>
                                <div style="margin-top:30px">金沫旅游</div>
                            </div>
                        </div>

                        <el-tabs v-model="activeName" @tab-click="handleClick(activeName)" class="ch-login-right-box">
                            <el-tab-pane label="账号密码登录" name="1">
                                <!-- 账号密码登录 -->
                                <div v-if="activeName == '1'">
                                    <el-form :model="form" :rules="rules" ref="form" label-width="0">
                                        <el-form-item prop="account">
                                            <el-input placeholder="请输入注册手机号" v-model="form.account"></el-input>
                                        </el-form-item>
                                        <el-form-item prop="password">
                                            <el-input placeholder="请输入登录密码" type="password" v-model="form.password"
                                                show-password>
                                            </el-input>
                                        </el-form-item>
                                        <!--<el-form-item prop="code">
                  <el-input placeholder="验证码" v-model="form.code"></el-input>
                </el-form-item>-->
                                        <div class="vc-line">
                                            <el-form-item prop="code">
                                                <el-input class="vcCode" placeholder="请输入验证码" v-model="form.code"
                                                    clearable @keyup.native.enter="onSubmitForm()"
                                                    style="width:167px;"></el-input>
                                            </el-form-item>
                                            <div class="ImgBox" style="cursor: pointer;" @click="getQRCode">
                                                <el-image :src="YzCode" v-loading="config.codeLoading">
                                                    <div slot="error" class="image-slot"></div>
                                                </el-image>
                                            </div>
                                        </div>
                                        <el-form-item>
                                            <el-button type="primary" style="width: 100%;display: block;"
                                                @click="onSubmitForm">登录</el-button>
                                        </el-form-item>
                                        <el-form-item>
                                            <div style="color: #222222;font-size:14px;text-align: center;">
                                                <span>还没加入我们？马上</span>
                                                <el-button @click="onRegister(1)" type="text">注册</el-button>
                                            </div>
                                        </el-form-item>
                                        <el-form-item style="text-align: center">
                                            <el-button v-if="false" @click="dialogVisible = true"
                                                type="text">忘记密码</el-button>
                                            <el-button @click="toHome" icon="el-icon-back" type="text">返回主页</el-button>
                                        </el-form-item>

                                        <el-dialog title="忘记密码" :visible.sync="dialogVisible" width="35%">
                                            <el-form :model="optForm" :rules="optRules" ref="optForm" label-width="100"
                                                :inline="true">
                                                <el-form-item prop="phone" label="手机号">
                                                    <el-input v-model="optForm.phone"></el-input>
                                                </el-form-item>
                                                <el-form-item prop="smsCode" label="验证码">
                                                    <div style="display: flex;">
                                                        <el-input v-model="optForm.smsCode"></el-input>
                                                        <el-button :disabled="vCodeTimer < 30" style="margin-left:10px;"
                                                            type="success" plain @click="getOpt">{{ vCodeStr
                                                            }}</el-button>
                                                    </div>
                                                </el-form-item>
                                                <el-form-item prop="password" label="新密码">
                                                    <el-input v-model="optForm.password"></el-input>
                                                </el-form-item>
                                            </el-form>
                                            <span slot="footer" class="dialog-footer">
                                                <el-button @click="dialogVisible = false">取 消</el-button>
                                                <el-button type="primary" @click="findPassword">确 定</el-button>
                                            </span>
                                        </el-dialog>

                                    </el-form>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane v-if="false" label="数字证书登录(CA登录)" name="2">
                                <!-- 数字证书登录(CA登录) -->
                                <div v-if="activeName == '2'">
                                    <el-form :model="form" :rules="rules" ref="form" label-width="0">
                                        <div class="ca_box">
                                            <div class="notice">请插入数字证书</div>
                                            <img src="../../assets/lock.png" />
                                        </div>
                                        <el-form-item>
                                            <el-button type="text" @click="downLoadCA">工具&CA驱动下载</el-button>
                                        </el-form-item>
                                        <el-form-item>
                                            <el-button type="primary" style="width: 100%;display: block;"
                                                @click="caSubmit">登录</el-button>
                                        </el-form-item>
                                        <el-form-item>
                                            <div style="color: #222222;font-size:14px;text-align: center;">
                                                <span>还没加入我们？马上</span>
                                                <el-button @click="onRegister(2)" type="text">注册</el-button>
                                            </div>
                                        </el-form-item>



                                    </el-form>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
            </div>

        </el-main>
        <el-footer height="auto" class="el-footer">
            <page-footer />
        </el-footer>
    </el-container>
</template>

<script>
import headerView from "./header";
import pageFooter from "../../layout/components/pageFooter";
import Images from "../../assets/images";
import login from "@/api/login/login"
import { Message } from 'element-ui'

export default {
    data() {
        return {
            timer: null,
            loginLoading: false,
            activeName: '1',
            loginFlag: true,
            dialogVisible: false,
            background: Images.login_background,
            form: {},
            optForm: {},
            YzCode: '', // 验证码图片
            vCodeStr: '获取验证码',
            vCodeTimer: 30,
            config: { codeLoading: false },
            rules: {
                password: [
                    { required: true, message: '此项不能为空', trigger: 'blur' },
                ],
                account: [
                    { required: true, message: '此项不能为空', trigger: 'blur' },
                ],
                code: [
                    { required: true, message: '此项不能为空', trigger: 'blur' },
                ],
            },
            optRules: {
                phone: [
                    { required: true, message: '此项不能为空', trigger: 'blur' },
                ],
                smsCode: [
                    { required: true, message: '此项不能为空', trigger: 'blur' },
                ],
                password: [
                    { required: true, trigger: 'blur', message: '此项不能为空', },
                    { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\.]{8,20}$/, message: '密码需同时包含字母大小写、数字、特殊字符！', trigger: 'blur' },
                    { min: 8, max: 20, message: '密码长度需在 8到 20 位之间', trigger: 'blur' }
                ],
            }
        };
    },
    components: {
        pageFooter,
        headerView,
    },
    created() {
        this.getQRCode()
    },
    methods: {

        toHome() {
            this.$router.push("/home")
        },
        handleClick(active) {
            if (active == '2') {
                // this.$CA.topEsaInit("both");
            }
        },

        //获取验证码
        getOpt() {
            if (this.optForm.phone) {
                let data = {
                    phone: this.optForm.phone
                }
                login.getVCode(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.message)
                    } else {
                        this.$message.warning(res.message);
                        this.timeoutFuc()
                    }
                })
            } else {
                this.$message.warning("请输入手机号")
            }
        },
        timeoutFuc() {
            this.timeoutIndex = setInterval(() => {
                if (this.vCodeTimer <= 1) {
                    this.vCodeStr = "获取验证码"
                    this.vCodeTimer = 30
                    clearInterval(this.timeoutIndex)
                    this.timeoutIndex = null
                    return
                } else {
                    this.vCodeTimer = this.vCodeTimer - 1
                    this.vCodeStr = this.vCodeTimer + "S"
                }
            }, 1000)
        },
        //忘记密码，重置密吗 
        findPassword() {
            this.$refs["optForm"].validate((valid) => {
                if (valid) {
                    login.findPassword(this.optForm).then(res => {
                        if (res.code == 0) {
                            this.$message.success(res.message)
                            // Message.success("修改密码成功")
                            this.dialogVisible = false
                        } else {
                            // this.$message.warning(res.msg);
                            Message.error(res.message)
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        open() {
            this.$confirm('当前账还未绑定CA证书,是否立即办理认证？', '提示', {
                confirmButtonText: '办理',
                cancelButtonText: '暂不',
                type: 'warning',
                center: true
            }).then(() => {
                // this.$message({
                //   type: 'success',
                //   message: '删除成功!'
                // });
                this.$router.push('/CAtransact')
            }).catch(() => {
            });
        },
        onSubmitForm() {
            this.$refs["form"].validate((valid) => {
                console.log(this.form);
                if (valid) {
                    login.login(this.form).then(res => {
                        if (res.code == 0) {

                            localStorage.setItem("userInfo", JSON.stringify(res.data));
                            this.$router.push('/home');
                            if (!res.data.ifLock) {
                                // this.open()
                            }

                        } else {
                            console.log('res', res);
                            this.$message.error(res);
                            this.getQRCode();
                        }
                    }
                    )
                } else {
                    return false;
                }
            });
        },
        // 下载CA
        downLoadCA() {
            // let url = window.URL.createObjectURL(new Blob(['https://bidding-oa.oss-cn-chengdu.aliyuncs.com/files/share/CA%E9%A9%B1%E5%8A%A8.zip']));
            let link = document.createElement('a');
            link.style.display = 'none';
            // link.href = 'https://bidding-oa.oss-cn-chengdu.aliyuncs.com/files/share/CA%E9%A9%B1%E5%8A%A8.zip';
            link.href = 'https://www.zyzhjcxgpt.com/oss/bidding-oa/files/share/CA%E5%B7%A5%E5%85%B7-%E5%A4%A9%E5%A8%81%E7%9B%BE%E5%AE%A2%E6%88%B7%E7%AB%AF.exe';
            link.setAttribute('download', 'CA驱动.zip');
            document.body.appendChild(link);
            link.click();
            link.remove()
        },
        // ca登录
        caSubmit() {
            clearInterval(this.timer);
            let count = 1
            this.timer = setInterval(() => {
                count--;
                this.$CA.topEsaInit("both");
                if (count <= 0) {
                    clearInterval(this.timer)
                    if (!this.$CA.getSignCertInfo()) {
                        this.$message.warning("未安装数字证书，或未找到符合License的数字证书");
                        return
                    }
                    let serialNumber = this.$CA.getSignCertInfo();
                    login.loginIfLockCa({
                        caSerialNumber: serialNumber,
                    }).then(res => {
                        if (res.code == 0) {
                            if (res.data) {
                                localStorage.setItem("userInfo", JSON.stringify(res.data));
                                this.$message.success('CA登录成功');
                                this.$router.push('/home');
                            } else {
                                this.activeName = '1';
                                this.$message.warning('请先将CA证书与用户进行绑定后在使用CA登录');
                                this.loginFlag = false;
                            }
                        } else {
                            console.log('res', res);
                            this.$message.error(res);
                        }
                    })
                }
            }, 1000);
        },
        // 绑定ca
        // lockCa() {
        //   if (!this.$CA.getSignCertInfo()) {
        //     this.$message.warning("未安装数字证书，或未找到符合License的数字证书");
        //     return
        //   }
        //   let serialNumber = this.$CA.getSignCertInfo();
        //   login.lockCa({
        //     caSerialNumber: serialNumber,
        //   }).then(res => {
        //     if (res.code == 0) {

        //     } else {
        //       console.log('res', res);
        //       this.$message.error(res);
        //     }
        //   })
        // },
        onRegister(way) {
            if (way == 1) {
                this.$router.push("/register");
            }
            if (way == 2) {
                // window.location.href='https://demo.itruscloud.com/certsaas_cloud_portal/#/createOrder?productCode=CERT652918'
                window.open('https://demo.itruscloud.com/certsaas_cloud_portal/#/createOrder?productCode=CERT652918')
            }
        },

        // 获取验证码
        getQRCode() {
            this.$nextTick(() => {
                this.config.codeLoading = true
            });
            this.YzCode = '';
            login.verifyCode().then(res => {
                this.YzCode = res.data.base64;
                this.form.uuid = res.data.uuid
                this.config.codeLoading = false
            })
        },
    },
    destroyed() {
        clearInterval(this.timer);
    },
};

</script>
<style lang="less" scoped>
.el-header {
    background-color: #ffffff;
}

.el-main {
    padding: 0;
}

.el-footer {
    padding: 0;
}

.ch-box {
    background-size: cover;
}

.ch-login-box {
    height: 892px;
    display: flex;
    align-items: center;

    .ch-login-left-box {
        flex: 1;
        display: flex;
        justify-content: center;

        .text-box {
            font-size: 36px;
            line-height: 42px;
            color: #ffffff;
        }
    }

    .ch-login-right-box {
        background-color: #fff;
        padding: 30px;

        /deep/.el-tabs__item {
            color: #222222;
            font-size: 24px;
            margin-bottom: 10px;
        }

        .ca_box {
            text-align: center;

            .notice {
                color: #222222;
                font-size: 24px;
                margin: 20px auto;
            }

            img {
                width: 90px;
            }
        }

    }
}

.ch-title {
    color: #222222;
    font-size: 24px;
}

/deep/ .el-card__header {
    border: none;
}

.vc-line {
    display: flex;
    justify-content: space-between;

    .ImgBox {
        width: 143px;
        height: 45px;
        background: #8489ce;
        opacity: 0.47;
        border-radius: 4px;
        overflow: hidden;

        .el-image {
            width: 100%;
            height: 100%;
        }
    }

    .getAU {
        text-align: right;
        color: #ffffff;
        font-size: 14px;
        width: 134px;
        height: 45px;
        line-height: 45px;
        padding: 0;
    }
}
</style>
